import React from "react";

const SIZE_CLASS = {
  sm: "dashboard-icon-sm",
  regular: "dashboard-icon",
  lg: "dashboard-icon-lg",
};

/**
 * Dashboard Icon — sm 12px · regular 14px · lg 16px.
 * Pass icon markup as children (e.g. `<i className="fi fi-rs-user" />`).
 * Use variant="short-text" for numeric / short text markers (max 13px / 600).
 */
const DashboardIcon = ({
  size = "regular",
  variant = "icon",
  as: Tag = "span",
  children,
  className = "",
  ...rest
}) => {
  if (variant === "short-text") {
    return (
      <Tag className={`dashboard-icon-short-text ${className}`.trim()} {...rest}>
        {children}
      </Tag>
    );
  }

  const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.regular;

  return (
    <Tag
      className={`inline-flex items-center justify-center shrink-0 ${sizeClass} ${className}`.trim()}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default DashboardIcon;
